













import scssVariable from '@/assets/style/variables.scss';
import moment from 'moment';
import { Vue, Component, Prop } from 'vue-property-decorator';

import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';
import { ADJUSTMENT_TYPE } from '@/const/types';
import { STATUS } from '@/const/status';
import { ADJUSTMENT_MAP } from '@/const/options';
import { AdsetSummaryType, IAdsetSummaryRow, IPrice } from '@/pages/report/campaign/adset/detailTypes';
import { IGridOptions, DefaultColumnOptions, NumberColumnOptions, DefaultGridOptions } from '@/const/options/TuiGridTypes';

import { Grid } from '@toast-ui/vue-grid';

import { TUI_FORMAT } from '@/utils/toastGrid_formatter';

@Component<GridAdsetDetail>({
    name: 'GridAdsetDetail',
    components: {
        Grid,
    }
})
export default class GridAdsetDetail extends Vue {
    @Prop({ type: Array, default: true }) private data!: AdsetSummaryType;
    private compTerms = compTerms;
    
    private gridOptions: IGridOptions = {
        ...DefaultGridOptions,
        treeColumnOptions: {
            useIcon: true,
            name: 'name',
            useCascadingCheckbox: false,
        },
        summary: {
            defaultContent: '',
            position: 'bottom',
            height: 40,
            columnContent: {
                name: { template: (summary: tuiGrid.IValueMap) => '<strong>TOTAL</strong>' },
                impression: {template: (summary: tuiGrid.IValueMap) => this.summaryFormat(summary, 'sum', '회', 'impression')},
                click: {template: (summary: tuiGrid.IValueMap) => this.summaryFormat(summary, 'sum', '회', 'click')},
                ctr: {template: (summary: tuiGrid.IValueMap) => this.summaryFormat(summary, 'calc', '%', 'ctr')},
                dailyBudget: {template: (summary: tuiGrid.IValueMap) => this.summaryFormat(summary, 'sum', '회', 'dailyBudget')},
                spentBudget: {template: (summary: tuiGrid.IValueMap) => this.summaryFormat(summary, 'sum', '회', 'spentBudget')},
            }
        },
        header: {
            height: 80,
        },
        columns: [
            { title: compTerms.column.adset.name + ' (광고세트, 인벤토리)', name: 'name', ...DefaultColumnOptions, minWidth: 300 },
            { title: compTerms.column.status, name: 'status', ...DefaultColumnOptions, minWidth: 80, align: 'center', formatter: this.explainFormat },
            { title: compTerms.column.date, name: 'reportDate', minWidth: 200, align: 'center', formatter: this.dateFormat},
            { title: compTerms.column.price, name: 'price', ...NumberColumnOptions, formatter: (v,row,col) => {
                const result = this.numberFormat(v,row,col);
                if (result === '- ') return '';
                return result
            }  },
            { title: compTerms.column.impression, name: 'impression', ...NumberColumnOptions, formatter: (v,row,col) => this.numberFormat(v,row,col) + '회'  },
            { title: compTerms.column.click, name: 'click', ...NumberColumnOptions, formatter: (v,row,col) => this.numberFormat(v,row,col) + '회'  },
            { title: compTerms.column.ctr, name: 'ctr', ...NumberColumnOptions, formatter: (v,row,col) => this.numberFormat(v,row,col) + '%'  },
            { title: compTerms.column.dailyBudget, name: 'dailyBudget', ...NumberColumnOptions, formatter: (v,row,col) => this.numberFormat(v,row,col) + '원'  },
            { title: compTerms.column.spentBudget, name: 'spentBudget', ...NumberColumnOptions, formatter: (v,row,col) => this.numberFormat(v,row,col) + '원'  },
            { title: compTerms.column.beginDate, name: 'beginDate', minWidth: 200, align: 'center', formatter: this.dateFormat},
            { title: compTerms.column.endDate, name: 'endDate', minWidth: 200, align: 'center', formatter: this.dateFormat},
        ]
    }
    
    private summaryFormat(params: tuiGrid.IValueMap, property: string, unit: string, columnName: string): string {
        if (property === 'calc') {
            const imp = this.data.map((row: IAdsetSummaryRow) => Number(row.impression)).reduce((prev: number, curr: number) => prev + (curr > 0 ? curr : 0), 0);
            const click = this.data.map((row: IAdsetSummaryRow) => Number(row.click)).reduce((prev: number, curr: number) => prev + (curr > 0 ? curr : 0), 0);
            return '<strong>' + (imp > 0 ? TUI_FORMAT.NumberFormat( (click / imp) * 100) : ' - ') + '</strong>' + unit;
        }
        params.sum = 0; params.avg = 0; params.min = Number.MAX_SAFE_INTEGER; params.max = Number.MIN_SAFE_INTEGER; params.cnt = 0;
        this.data.forEach((row: IAdsetSummaryRow) => {
            const num = Number.parseFloat((row as any)[columnName]);
            if (!Number.isNaN(num)) {
                params.cnt++;
                if (num >= 0) {
                    params.sum += num;
                    if (params.max < num) params.max = num;
                    if (params.min > num) params.min = num;
                }
            }
        })
        if (params.max === Number.MIN_SAFE_INTEGER) params.max = 0;
        if (params.min === Number.MAX_SAFE_INTEGER) params.min = 0;
        params.avg = params.cnt === 0 ? 0 : params.sum / params.cnt;
        
        return TUI_FORMAT.SummaryFormat(params, property, unit);
    }

    private explainFormat(cellValue: string, rowAttrs: tuiGrid.IRow, column: tuiGrid.IColumnInfoOptions): string {
        if (cellValue !== undefined && cellValue !== null) {
            const status = Number.parseInt(cellValue);
            if (!Number.isNaN(status)) {
                if (status & STATUS.ACTIVE) return '<strong style="color: '+scssVariable.success+';">활성</strong>';
                else return '<strong style="color: '+scssVariable.info+'">비활성</strong>'; 
            }    
        }
        return '<strong title="문의가 필요합니다." style="color: '+scssVariable.danger+'">[비정상]</strong>';
    }
    
    private numberFormat(cellValue: any, rowAttrs: tuiGrid.IRow, column: tuiGrid.IColumnInfoOptions): string {
        if (cellValue !== undefined && cellValue !== null && (Object.isExtensible(cellValue) || cellValue >= 0)) {
            if (column.name === 'price') {
                const v = (cellValue as IPrice);
                if (!Number.isNaN(v.value)) {
                    return '<span class="'+(this as any).$style.priceAdjustment+'">' + ADJUSTMENT_MAP[v.type] + '</span>' + (v.type !== ADJUSTMENT_TYPE.FREE ? TUI_FORMAT.NumberFormat(v.value) + ' 원': '-')
                }
            } else {
                const num = Number.parseFloat(cellValue as string);
                if (!Number.isNaN(num)) {
                    return TUI_FORMAT.NumberFormat(num);
                }
            }
        }
        return '- ';
    }

    private dateFormat(cellValue: string, rowAttrs: tuiGrid.IRow, column: tuiGrid.IColumnInfoOptions): string {
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
            return moment(cellValue).format('YYYY-MM-DD');
        }
        if (column.name === 'reportDate') {
            return '-';
        }
        return '계속';
    }

    private resizeHandler(event: Event) {
        this.$emit('resize', event);
    }
    
    private expandedHandler({ rowKey, descendantRowKeys, instance }: tuiGrid.IColumnEventOptions & { descendantRowKeys: number[] | string[] | undefined[] }) {
        this.$emit('expanded', { rowKey, descendantRowKeys, instance });
    }    
}
